// extracted by mini-css-extract-plugin
export default {"a":"style_a__6WMZE","img":"style_img__CIKzX"};